export const PAYMENT_LOADING = "PAYMENT_LOADING";
export const PAYMENT_SET_SUBSCRIPTIONS = "PAYMENT_SET_SUBSCRIPTIONS";
export const PAYMENT_SET_INVOICES = "PAYMENT_SET_INVOICES";
export const PAYMENT_SET_PLANS = "PAYMENT_SET_PLANS";